import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { queryKeys } from '../lib/queryClient';
import { logAction } from '../lib/actionLogger';

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings.all,
    queryFn: async () => {
      const data = await api.get('/settings');
      // Server returns the data JSONB directly; wrap it to match expected shape
      return { data: data || {} };
    },
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (updates) => {
      // Components pass the full settings object { data: {...} }
      // The server expects { data: <JSON> }
      const dataPayload = updates.data || updates;
      await api.put('/settings', { data: dataPayload });
      return { data: dataPayload };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.settings.all });
      logAction({
        action: 'Update Settings',
        description: 'Updated portal settings',
      });
    },
  });
}
